const MEReportingRoutes = [
    {
      path: '/reports/beneficiary-summery',
      name: 'BeneficiarySummery',
      meta: { 
        requiresAuth: true,
        permission: "beneficiary-summary",
      },
      component: () =>
        import(
          "../pages/MEReporting/BeneficiaryReporting/BeneficiarySummery.vue"
        ),
    },
];

export default MEReportingRoutes;
